import { motion } from "framer-motion";
import { B } from "../data/pillars";

const LEVELS = [
  {
    n: 1,
    label: "Reactive",
    color: B.red,
    desc: "Break-fix, no visibility, high risk exposure. Technology is reactive and uncoordinated.",
    character: "Don't know what you don't know. Too flexible. Service quality and budget unpredictable. Need for IT's strategic value unrecognized."
  },
  {
    n: 2,
    label: "Emerging",
    color: B.orange,
    desc: "Some tools deployed but inconsistently managed. Partial visibility, manual processes.",
    character: "Realizing what you don't know. Still too flexible. Service quality and budget unpredictable. Initial awareness of need for IT's strategic value."
  },
  {
    n: 3,
    label: "Scaling",
    color: B.yellow,
    desc: "Standardized tools with policies in place. Co-managed or managed IT with documented processes.",
    character: "Reduced flexibility yields increased service quality and budget predictability. Basic business value delivered."
  },
  {
    n: 4,
    label: "Proactive",
    color: B.green,
    desc: "Fully managed, automated, and monitored. Strategic technology roadmap aligned to business goals.",
    character: "Stringent standards and minimized flexibility. Strong service quality and high budget efficiency. Strategic alignment basics in place."
  },
  {
    n: 5,
    label: "Optimized",
    color: B.teal,
    desc: "AI-driven, self-healing infrastructure. Technology is a competitive differentiator.",
    character: "Adding controlled flexibility and enabling new lines of business or revenue with IT, integrated into or leading company strategy."
  },
];

export default function FrameworkModal({ onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: "fixed", inset: 0, background: "#000A", zIndex: 1000,
        display: "flex", alignItems: "center", justifyContent: "center", padding: 20
      }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, y: 30 }}
        animate={{ scale: 1, y: 0 }}
        style={{
          background: "#1A2E4A", borderRadius: 16, border: "1px solid #1E3A5F",
          maxWidth: 700, width: "100%", maxHeight: "85vh", overflow: "auto", padding: 32
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: B.white }}>OML Framework Guide</div>
            <div style={{ color: B.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, marginTop: 4 }}>OPERATIONAL MATURITY LEVEL · SCALES 1.0 – 5.0</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: B.subText, fontSize: 24, cursor: "pointer" }}>×</button>
        </div>

        <div style={{ background: "#122240", borderRadius: 10, padding: 18, marginBottom: 20, borderLeft: `4px solid ${B.blue}` }}>
          <div style={{ fontSize: 11, color: B.accent, fontWeight: 700, letterSpacing: 2, marginBottom: 8 }}>STRATEGIC FRAMEWORK</div>
          <p style={{ color: B.lightGray, fontSize: 14, lineHeight: 1.7, margin: 0 }}>
            "Operational Maturity Level (OML) is a five-stage framework that measures how standardized, automated, and strategic an organization's people, processes, and technology are."
          </p>
        </div>

        {LEVELS.map(lv => (
          <div key={lv.n} style={{ display: "flex", gap: 14, marginBottom: 20 }}>
            <div style={{
              width: 36, height: 36, borderRadius: "50%", background: lv.color,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 800, color: B.white, flexShrink: 0
            }}>
              {lv.n}
            </div>
            <div>
              <div style={{ color: lv.color, fontWeight: 700, fontSize: 15, marginBottom: 4 }}>OML {lv.n} – {lv.label}</div>
              <div style={{ color: B.white, fontSize: 13, lineHeight: 1.5, marginBottom: 6 }}>{lv.desc}</div>
              <div style={{ 
                color: B.lightGray, fontSize: 12, lineHeight: 1.5, fontStyle: "italic", 
                borderLeft: `2px solid ${lv.color}50`, paddingLeft: 12, marginTop: 4
              }}>
                <strong style={{ color: B.subText, display: "block", fontSize: 10, textTransform: "uppercase", letterSpacing: 1, marginBottom: 2, fontStyle: "normal" }}>Operational Character</strong>
                {lv.character}
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
}